export const LOAD_HCAPTCHA_EVENT = 'loadHCaptcha'
export const GET_HCAPTCHA_TOKEN_EVENT = 'getHCaptchToken'
